import { Group, Stack, Text } from '@mantine/core';

import { DrawerTemplateView } from '../../../drawer-template';
import { EmptyStateView } from '../../../empty-state';
import { CardBadgeView } from '../../../cards/atoms/CardBadge';
import { SurfaceView } from '../../atoms/Surface';
import type { HistoryListViewProps } from './HistoryList.types';

export function HistoryListView({
  opened,
  onClose,
  icon,
  title,
  items,
  emptyTitle,
  emptyDescription,
  size = 'md',
}: HistoryListViewProps) {
  return (
    <DrawerTemplateView opened={opened} onClose={onClose} icon={icon} title={title} size={size}>
      {items.length === 0 ? (
        <EmptyStateView variant="inline" title={emptyTitle} description={emptyDescription} />
      ) : (
        <Stack gap="sm">
          {items.map((item) => (
            <SurfaceView key={item.id}>
              <Group justify="space-between" mb={4}>
                <Text fw={600}>{item.value}</Text>
                {item.badgeLabel && <CardBadgeView label={item.badgeLabel} color={item.badgeColor} />}
              </Group>
              {item.comment && (
                <Text size="sm" c="dimmed">
                  {item.comment}
                </Text>
              )}
              <Text size="xs" c="dimmed" mt={4}>
                {item.timestamp}
              </Text>
            </SurfaceView>
          ))}
        </Stack>
      )}
    </DrawerTemplateView>
  );
}
